import { render, staticRenderFns } from "./TravelClaimPosted.vue?vue&type=template&id=4edd606c&"
import script from "./TravelClaimPosted.vue?vue&type=script&lang=js&"
export * from "./TravelClaimPosted.vue?vue&type=script&lang=js&"
import style0 from "./TravelClaimPosted.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TravelClaimPosted.vue"
export default component.exports